<script>
    export let current = 0;
    export let total = 0;
    $: percent = total > 0 ? Math.ceil(((current + 1) / total) * 100) : 0;
</script>

<div
    class="animate-pulse w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 my-1.5"
>
    <div
        class="bg-yellow-300 h-2.5 rounded-full content-center text-center text-sm"
        style="width: {percent}%"></div>
</div>
